import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCartOpen: false,
  cart: JSON.parse(localStorage.getItem('cart')) || [],
  items: [],
  message: '',
  error: null
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
      state.error = null;
    },

    addToCart: (state, action) => {
      const itemToAdd = action.payload.item;
      const existingItemIndex = state.cart.findIndex((item) => item.id === itemToAdd.id);

      // Check initial stock
      if (itemToAdd.count > itemToAdd.stock) {
        state.error = {
          drugId: itemToAdd.id,
          message: `Sorry, only ${itemToAdd.stock} items available in stock`
        };
        return;
      }

      if (existingItemIndex >= 0) {
        const newCount = state.cart[existingItemIndex].count + itemToAdd.count;
        if (newCount > itemToAdd.stock) {
          state.error = {
            drugId: itemToAdd.id,
            message: `Cannot add more items. Stock limit of ${itemToAdd.stock} would be exceeded.`
          };
          return;
        }
        state.cart[existingItemIndex].count = newCount;
      } else {
        state.cart.push(itemToAdd);
      }

      state.error = null;
      state.message = action.payload.message;
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter((item) => item.id !== action.payload.id);
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    increaseCount: (state, action) => {
      const itemIndex = state.cart.findIndex((item) => item.id === action.payload.id);
      if (itemIndex >= 0) {
        const item = state.cart[itemIndex];
        if (item.count >= item.stock) {
          state.error = `Cannot add more items. Stock limit of ${item.stock} reached.`;
          return;
        }
        item.count++;
        state.error = null;
        localStorage.setItem('cart', JSON.stringify(state.cart));
      }
    },

    decreaseCount: (state, action) => {
      state.cart = state.cart.map((item) => {
        if (item.id === action.payload.id && item.count > 1) {
          item.count--;
        }
        return item;
      });
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    setIsCartOpen: (state) => {
      state.isCartOpen = !state.isCartOpen;
    }
  }
});

export const {
  setItems,
  addToCart,
  removeFromCart,
  increaseCount,
  decreaseCount,
  setIsCartOpen
} = cartSlice.actions;

export default cartSlice.reducer;
